//clinic-manager/report/selectReportList
import http from  './axios'

export const getReport = param =>{return http.post("clinic-manager/report/selectReportList",param).then(res=>res.data.data)};
//明细
export const  getOrderDetail = param  =>{return http.post('partner-manager/order/selectPartnerOrderDetailById',param).then(res=>res.data.data)};
//打印
export const reportPrint = param =>{return http.post("partner-manager/reportManage/reportPrint",param).then(res=>res.data.data)};
//合并报告单
export const  getPrint = param  =>{return http.post('common/common/mergeReportPDF',param).then(res=>res.data.data)};

//批量下载
// export const downLoad = param =>{return http.get('common/common/reportBatchDownload',{params:param}).then(res=>res)};


// LODOP JPG形式
export const  getPrintJPG = param  =>{return http.post('common/common/mergeReportJPG',param).then(res=>res.data.data)};
//生成报告模板
export const  selectReportByCode = param  =>{return http.post('clinic-manager/report/selectReportByCode',param).then(res=>res.data.data)};



// WEBPACK FOOTER //
// ./src/api/report.js